import React from 'react';
import { Router, Route } from 'react-router-dom';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import {
  AppointmentsListScreen,
  ClientsScreen,
  ConsultationAddParticipantScreen,
  ConsultationOptionsScreen,
  ConsultationReassignScreen,
  ConsultationRecordingsScreen,
  ConsultationScreen,
  ConsultationsScreen,
  ConsultationStartScreen,
  ClientDetailsScreen,
  CreatePracticeScreen,
  DynamicLinkScreen,
  EmgHomeScreen,
  EmgVideoScreen,
  HomeScreen,
  InstantCompletedScreen,
  InstantHelpScreen,
  InstanHomeScreen,
  InstantLandingScreen,
  InstantSettingsScreen,
  InstantRecordingsScreen,
  InstantSignUpScreen,
  InstantVideoScreen,
  FrontDeskConsultationsScreen,
  FrontDeskHomeScreen,
  MyAccountScreen,
  PracticeAdminsAddEditScreen,
  PracticeAlertAddEditScreen,
  PracticeScreen,
  PracticeInfoEditScreen,
  PracticeBankAddEditScreen,
  PracticeFrontDeskAddEditScreen,
  PracticeLocationAddEditScreen,
  PracticeLocationDetailsScreen,
  PracticeStaffMemberDetailsScreen,
  PracticeNotificationPreferencesScreen,
  PracticeAssignClientScreen,
  PracticeLocationProvidersScreen,
  PracticeLocationClientsScreen,
  SettingsScreen,
  SignInScreen,
  SignUpScreen,
  StaffScreen,
  StripeRedirectScreen,
  SubscriptionDetailsScreen,
  SwitchAccountScreen,
  UserForgotPasswordScreen,
  UserSignInCodeScreen,
  UserProfileEditScreen,
  VideoCallScreen,
} from '../containers';
import { History as history, Routes as routes } from '../navigation';

toast.configure();

const App = () => {

  return (
    <div>
      <Router history={history}>
        <div>
          <Route path={`${routes.SIGN_IN}`} exact component={SignInScreen}/>
          <Route path={`${routes.SIGN_UP}`} exact component={SignUpScreen}/>
          <Route path={`${routes.HOME}`} exact component={HomeScreen}/>
          <Route path={`${routes.MY_ACCOUNT}`} exact component={MyAccountScreen}/>
          <Route path={`${routes.SETTINGS}`} exact component={SettingsScreen}/>
          <Route path={`${routes.SWITCH_ACCOUNTS}`} exact component={SwitchAccountScreen}/>
          <Route path={`${routes.PRACTICE}`} exact component={PracticeScreen}/>
          <Route path={`${routes.CONSULTATIONS}`} exact component={ConsultationsScreen}/>
          <Route path={`${routes.STAFF}`} exact component={StaffScreen}/>
          <Route path={`${routes.PRACTICE_LOCATION_EDIT}`} exact component={PracticeLocationAddEditScreen}/>
          <Route path={`${routes.CONSULTATION}`} exact component={ConsultationScreen}/>
          <Route path={`${routes.USER_PROFILE_EDIT}`} exact component={UserProfileEditScreen}/>
          <Route path={`${routes.PRACTICE_INFO_EDIT}`} exact component={PracticeInfoEditScreen}/>
          <Route path={`${routes.CONSULTATION_ADD_PARTICIPANT}`} exact component={ConsultationAddParticipantScreen}/>
          <Route path={`${routes.PRACTICE_STAFF_MEMBER_DETAILS}`} exact component={PracticeStaffMemberDetailsScreen}/>
          <Route path={`${routes.PRACTICE_ADMINS_EDIT}`} exact component={PracticeAdminsAddEditScreen}/>
          <Route path={`${routes.CONSULTATION_REASSIGN}`} exact component={ConsultationReassignScreen}/>
          <Route path={`${routes.PRACTICE_LOCATION_DETAILS}`} exact component={PracticeLocationDetailsScreen}/>
          <Route path={`${routes.PRACTICE_BANK_EDIT}`} exact component={PracticeBankAddEditScreen}/>
          <Route path={`${routes.CONSULTATION_START}`} exact component={ConsultationStartScreen}/>
          <Route path={`${routes.PRACTICE_FRONT_DESK_EDIT}`} exact component={PracticeFrontDeskAddEditScreen}/>
          <Route path={`${routes.FRONT_DESK_HOME}`} exact component={FrontDeskHomeScreen}/>
          <Route path={`${routes.PRACTICE_ASSIGN_CLIENT}`} exact component={PracticeAssignClientScreen}/>
          <Route path={`${routes.VIDEO_CALL}`} exact component={VideoCallScreen}/>
          <Route path={`${routes.CONSULTATION_OPTIONS}`} exact component={ConsultationOptionsScreen}/>
          <Route path={`${routes.CLIENTS}`} exact component={ClientsScreen}/>
          <Route path={`${routes.PRACTICE_ALERT_EDIT}`} exact component={PracticeAlertAddEditScreen}/>
          <Route path={`${routes.FRONT_DESK_CONSULTATIONS}`} exact component={FrontDeskConsultationsScreen}/>
          <Route path={`${routes.USER_FORGOT_PASSWORD}`} exact component={UserForgotPasswordScreen}/>
          <Route path={`${routes.EMG}`} exact component={EmgHomeScreen}/>
          <Route path={`${routes.DYNAMIC_LINKS}/:category/:id`} exact component={DynamicLinkScreen}/>
          <Route path={`${routes.EMG_VIDEO}/:code`} exact component={EmgVideoScreen}/>
          <Route path={`${routes.PRACTICE_NOTIFICATION_PREFERENCES}`} exact component={PracticeNotificationPreferencesScreen}/>
          <Route path={`${routes.STRIPE_REDIRECT}`} exact component={StripeRedirectScreen}/>
          <Route path={`${routes.APPOINTMENTS}`} exact component={AppointmentsListScreen}/>
          <Route path={`${routes.CONSULTATION_RECORDINGS}`} exact component={ConsultationRecordingsScreen}/>
          <Route path={`${routes.USER_SIGN_IN_CODE}`} exact component={UserSignInCodeScreen}/>
          <Route path={`${routes.CLIENT_DETAILS}`} exact component={ClientDetailsScreen}/>
          <Route path={`${routes.LOCATION_CLIENTS}`}     exact component={PracticeLocationClientsScreen}/>
          <Route path={`${routes.PRACTICE_PLANS}`}       exact component={CreatePracticeScreen}/>
          <Route path={`${routes.SUBSCRIPTION_DETAILS}`} exact component={SubscriptionDetailsScreen} />
          <Route path={`${routes.LOCATION_PROVIDERS}`}   exact component={PracticeLocationProvidersScreen} />

          <Route path={`${routes.INSTANT_HOME}`}        exact component={InstanHomeScreen}/>
          <Route path={`${routes.INSTANT_COMPLETED}`}   exact component={InstantCompletedScreen}/>
          <Route path={`${routes.INSTANT_RECORDINGS}`}  exact component={InstantRecordingsScreen}/>
          <Route path={`${routes.INSTANT_HELP}`}        exact component={InstantHelpScreen}/>
          <Route path={`${routes.INSTANT_VIDEO}/:code`} exact component={InstantVideoScreen}/>
        </div>
      </Router>
    </div>
  )
}

export default App;
